import React from 'react';

interface RequiredFieldLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  optionalHint?: string;
  className?: string;
}

export default function RequiredFieldLabel({
  htmlFor,
  children,
  required = false,
  optionalHint,
  className = 'block text-sm font-medium text-gray-700',
}: RequiredFieldLabelProps) {
  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
      {required && (
        <span className="ml-0.5 text-red-600" aria-hidden="true">
          *
        </span>
      )}
      {!required && optionalHint && (
        <span className="ml-1 font-normal text-gray-500">({optionalHint})</span>
      )}
    </label>
  );
}
